/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import { each } from 'meteora';
import Equalizer from '@meteora-digital/equalizer';
/* --------------------------------------------------
Equalizer
-------------------------------------------------- */

window.equalizers = {};

window.equalize = function () {
  for (var key in window.equalizers) {
    if (Object.hasOwnProperty.call(window.equalizers, key)) {
      window.equalizers[key].update();
    }
  }
};

window.addEventListener('initialize', function () {
  return window.equalize();
});
var index = 0;
each('[data-equalize]', function (container) {
  var ID = container.getAttribute('data-equalize'); // Set up the equalizer settings

  var settings = {
    container: container,
    identifiers: ID,
    rows: true
  };
  if (window.equalizers[ID]) ID = "".concat(ID, "-").concat(index);
  window.equalizers[ID] = new Equalizer(settings);
  index += 1;
});
each('[data-match-height]', function (container) {
  var ID = container.getAttribute('data-match-height'); // Set up the equalizer settings

  var settings = {
    container: container,
    identifiers: ID,
    rows: false
  };
  if (window.equalizers[ID]) ID = "".concat(ID, "-").concat(index);
  window.equalizers[ID] = new Equalizer(settings);
  index += 1;
});